<nav aria-label="Page navigation example" class="pag-nav" [hidden]="count == 0" screenSizeDetector [addClasses]="false" [componentId]="'-navigation'">
    <span class="page-num">Page {{currentPage}} of {{lastPageNum}}</span>
    <ul class="pagination">
        <li class="page-item" [ngClass] = "{'disabled': currentPage == 1}"><a class="prev-link page-link" (click)="changePage(-1)"><span>Previous</span></a></li>
        <li class="page-item" [ngClass] = "{'disabled': isLastPage}"><a class="next-link page-link" (click)="changePage(+1)"><span>Next</span></a></li>
    </ul>
</nav>  